<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { Primitive, type PrimitiveProps } from 'reka-ui';

import { cn } from '@/shared/lib/utils';

import { buttonVariants, type ButtonVariants } from '.';

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant'];
  size?: ButtonVariants['size'];
  class?: HTMLAttributes['class'];
  type?: 'button' | 'submit';
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
  type: 'button',
});
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :type="as === 'button' ? type : undefined"
    :class="cn(buttonVariants({ variant, size }), props.class)"
  >
    <slot />
  </Primitive>
</template>
